import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Link,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Divider,
} from "@mui/material";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import { API_KEYS, FMP_API_ENDPOINTS } from "../util/Constants";
import ReactTimeAgo from "react-time-ago";

const PROFILE_FONT = "'Lato', 'Helvetica Neue', Arial, sans-serif";
const CARD_HEADER_BG = "#f5f2ed";
const CARD_HEADER_TEXT = "#1a2744";
const BORDER_LIGHT = "#e8eef6";

export default function CompanyNews(props) {
  const [stateValues, setStateValues] = useState({
    news: [],
  });

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const symbol = props.symbol;
        if (!symbol) {
          return;
        }

        const url = `${FMP_API_ENDPOINTS.STOCK_NEWS(props.symbol)}&${
          API_KEYS.FMP_API_KEY
        }`;
        const response = await axios.get(url);

        if (Array.isArray(response.data)) {
          setStateValues({
            news: response.data,
          });
        } else {
          setStateValues({
            news: [],
          });
        }
      } catch (error) {
        console.error("Error fetching news:", error);
        setStateValues({
          news: [],
        });
      }
    };

    fetchNews();
  }, [props.symbol]);

  return (
    <Table size="small" sx={{ width: "100%", fontFamily: PROFILE_FONT }}>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={3}
            sx={{
              fontFamily: PROFILE_FONT,
              backgroundColor: CARD_HEADER_BG,
              color: CARD_HEADER_TEXT,
              fontWeight: 700,
              fontSize: "1rem",
              py: 1.25,
              px: 2,
              borderBottom: `1px solid ${BORDER_LIGHT}`,
              position: "sticky",
              top: 0,
              zIndex: 1,
              background: CARD_HEADER_BG,
            }}
          >
            Latest News
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {stateValues.news && stateValues.news.length > 0 ? (
          stateValues.news.slice(0, 10).map((newsItem, index) => (
            <React.Fragment key={index}>
              <TableRow
                sx={{
                  "&:hover": {
                    backgroundColor: CARD_HEADER_BG,
                  },
                }}
              >
                <TableCell sx={{ py: 1, border: 0 }}>
                  <Box
                    sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                  >
                    <Box sx={{ width: "100px", flexShrink: 0 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          whiteSpace: "nowrap",
                          fontSize: "0.75rem",
                        }}
                      >
                        <ReactTimeAgo
                          date={newsItem.publishedDate}
                          locale="en-US"
                        />
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 0.5 }}
                      >
                        <Link
                          href={newsItem.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            color: "#1a4075",
                            textDecoration: "none",
                            fontSize: "0.95rem",
                            fontWeight: 600,
                            lineHeight: 1.3,
                            "&:hover": {
                              color: "#0f2d52",
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {newsItem.title}{" "}
                          <Typography
                            component="span"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.85rem",
                            }}
                          >
                            (Source: {newsItem.site})
                          </Typography>
                        </Link>
                      </Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontSize: "0.85rem",
                          lineHeight: 1.4,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {newsItem.text}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              {index < stateValues.news.length - 1 && (
                <TableRow>
                  <TableCell sx={{ py: 0.5, border: 0 }}>
                    <Divider />
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))
        ) : (
          <TableRow>
            <TableCell>
              <Typography variant="body2" color="text.secondary" align="center">
                No news available
              </Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
